import {Type} from '@angular/core';

import {AbstractTriggerEntity} from './trigger.entity';

export const TriggerReset = {
	Never: 'Never',
	StationChange: 'StationChange',
	Always: 'Always',
} as const;
export type TriggerReset = (typeof TriggerReset)[keyof typeof TriggerReset];

/* -------------------------------------------------------------------------------------------------------------- */
export type TriggerEntityClassMetadata = {
	name: `${string}-trigger`;
	type: AbstractTriggerEntity['event'];
	label: string;
	summary: ((trigger: AbstractTriggerEntity) => string) | string;
	updateValueClassSelector?: 'dc-trigger-notification-timeout-value';
	availableActionClasses?: Type<AbstractTriggerEntity['action']>[];
};
